"use client";

import React from "react";

import { cn } from "utils";

export interface ChatCardIntroProps {
  /** 主标题 */
  title: string;
  /** 说明正文 */
  description: string;
  /** 标题使用较大字号（Daily Discovery 部分稿为 title 级） */
  titleVariant?: "default" | "large";
  className?: string;
}

export const ChatCardIntro: React.FC<ChatCardIntroProps> = ({
  title,
  description,
  titleVariant = "default",
  className,
}) => (
  <div className={cn("flex flex-col gap-0.5", className)}>
    <p
      className={cn(
        "text-content_primary",
        titleVariant === "large" ? "title_l" : "body_bold_m",
      )}
    >
      {title}
    </p>
    <p className="body_m text-content_secondary whitespace-pre-wrap">
      {description}
    </p>
  </div>
);
